<template>

    <div>
        <div class="box" >
                <div class="btn-box">
                <BBtnPrimary
                        :clicked="openUploadVideoPopup"
                        btn-txt="上传视频Popup"/>
                <BBtnPrimary
                        :clicked="openUploadImgPopup"
                        btn-txt="上传图片Popup"/>
                </div>
              
            <div class="video-box">
                <div  class="inner-box">
                    <div v-for="(item,index) in imgList" :key="index" class="item">
                        <img style="width:460px;height:300px;" src="../../assets/avatar.jpg"/>
                        <label style="display: block;text-align:center">aaaaaaaaaaaaaaaaaaaa</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { courseClassFileSave } from "@/api/classManagement";
    import BBtnPrimary from "../../components2/BBtnPrimary";
    import Hub from '../../events/Hub';
    import UploadVideo from "../../views2/sample/UploadVideo";
    import UploadImage from "../../views2/sample/UploadImage";
    import Vue from "vue";
    export default {
        name: "courseClassActual",
        components: {
            BBtnPrimary,
        },
        props: {
            classId: Number
        },
        data() {
            return {
                imgData: [],
                snackbar: false,
                timeout: 2000,
                snackbarColor: 'error',
                snackbarText: '',
                returnData: "this is return data",
                fileType: '',
                imgList: [
                        {
                            id: 1,
                            fileURL: "../../assets/avatar.jpg",
                            answerFlg: "",
                            content: "",
                            checkedFlag: false,
                        },
                        {
                            id: 2,
                            fileURL: "https://learningdev.obs.cn-southwest-2.myhuaweiclo…com/20210123/c3b346c4ae5848908fdb7a3dcc0a24d4.jpg",
                            answerFlg: "",
                            content: "",
                            checkedFlag: false,
                        },
                         {
                            id: 3,
                            fileURL: "https://learningdev.obs.cn-southwest-2.myhuaweiclo…com/20210123/0def8d39ba6748bb823f625273fa33f9.jpg",
                            answerFlg: "",
                            content: "",
                            checkedFlag: false,
                        },
                          {
                            id: 3,
                            fileURL: "https://learningdev.obs.cn-southwest-2.myhuaweiclo…com/20210123/0def8d39ba6748bb823f625273fa33f9.jpg",
                            answerFlg: "",
                            content: "",
                            checkedFlag: false,
                        },
                        {
                            id: 3,
                            fileURL: "https://learningdev.obs.cn-southwest-2.myhuaweiclo…com/20210123/0def8d39ba6748bb823f625273fa33f9.jpg",
                            answerFlg: "",
                            content: "",
                            checkedFlag: false,
                        },
                ],
            }
        },
        mounted () {
            //alert('传过来的id'+this.classId)
            this.$nextTick(
                function() {
                    Hub.$on("modal-confirm", this.set);
                }.bind(this)
            );
        },
        methods: {
            openUploadImgPopup() {
                Hub.$emit('open-modal');
                Hub.$emit('set-modal-data', this.imgData, '上传图片', UploadImage);
            },
            openUploadVideoPopup() {
                Hub.$emit('open-modal');
                Hub.$emit('set-modal-data', this.imgData, '上传视频', UploadVideo);
            },
            set(value) {

                if (value[0]) {
                    this.imgData = value;
                    this.fileType = "01"
                    this.saveCourseClassFile();
                }
            },
            async saveCourseClassFile() {
                var param = {
                    courseClassId: 1,
                    fileUrlList: this.imgData,
                    fileType: this.fileType,
                };
                const data = await courseClassFileSave(param);
                if (data.code === 0) {
                    Vue.prototype.$vsnackbar.show(data.data.msg);
                } else {
                    Vue.prototype.$vsnackbar.show(data.data.msg);
                }
            },
        },
        watch: {

        },
        destroyed() {
            Hub.$off("modal-confirm", this.set);
        },
    }
</script>

<style scoped>
    .box {
        display: flex;
        flex-direction: column;
    }

    .btn-box{
        display: flex;
        width: auto;
        height: 40px;
        padding-top: 20px;
        margin-left:1300px;
    }

    .button {
        align-self: flex-start;
    }

    .video-box {
        display: flex;
        width: auto;
        height: 800px;
        margin: 10px 0;
    }

    .inner-box {
        display: flex;
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
        position: relative;
        height: auto;
        align-items: center;
        margin: 10px;
    }
    .item {
        margin-left: 30px;
        margin-right: 20px;
        width: 460px;
        height: 300px;
        background-color: lightslategrey;
    }

    .video {
        width: 448px;
        height: 273px;
        background: #000000;
    }

    .delete-img {
        position: relative;
        width: 23px;
        height: 23px;
        left: -12px;
        bottom: 100px;
    }

</style>